<div class="card card-custom h-100">
  <div class="card-header">
    <div class="d-flex">
      <div style="width: 20vw">
        <mat-form-field class="w-100">
          <mat-label>Search</mat-label>
          <input matInput #search />
          <mat-icon matSuffix>search</mat-icon>
        </mat-form-field>
        <mat-form-field class="w-100">
          <mat-label>Team</mat-label>
          <mat-select #team>
            <mat-option value="">All</mat-option>
            <mat-option *ngFor="let team of teams" [value]="team.id">{{ team.name }}</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div style="width: 20vw" class="d-flex align-items-end ml-4">
        <mat-form-field class="w-100">
          <mat-label>Type</mat-label>
          <mat-select #type>
            <mat-option value="false">Regular</mat-option>
            <mat-option value="true">Backstage</mat-option>
            <mat-option value="">All</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>
    <div class="d-flex flex-column justify-content-end">
      <div *ngFor="let type of transactionTypes">
        <i
          [class]="
            'fas fa-square mr-2 text-' +
            (type === TransactionType.TASK
              ? 'primary'
              : type === TransactionType.WORKFLOW_QUEUE
              ? 'danger'
              : 'warning')
          "
        ></i>
        <span>{{
          type === TransactionType.TASK
            ? 'Task'
            : type === TransactionType.WORKFLOW_QUEUE
            ? 'Workflow Queue'
            : 'Note'
        }}</span>
      </div>
    </div>
  </div>
  <div class="card-body d-flex flex-column my-5">
    <div class="d-flex align-items-center font-weight-bolder p-2 mb-4">
      <div style="width: 160px" class="px-2">Date Created</div>
      <div style="width: 230px" class="flex-grow-1 px-2">Patient Name</div>
      <div style="width: 230px" class="flex-grow-1 px-2">Title/Team</div>
      <div style="width: 230px" class="px-2">Last Comment or Note</div>
      <div style="width: 160px" class="px-2">Last Modified Date</div>
      <div style="width: 160px" class="px-2">Last Modified By</div>
      <div style="width: 85px" class="px-2"></div>
    </div>
    <div *ngIf="loading$ | async" class="d-flex flex-center text-primary mt-5">
      <div class="spinner-grow">
        <span class="sr-only">Loading...</span>
      </div>
    </div>
    <div
      *ngIf="!((loading$ | async) || records?.length)"
      class="mat-table-message text-center mt-5"
    >
      No Records Found
    </div>
    <div
      *ngIf="!(loading$ | async) && records?.length"
      class="scroll px-2"
      [perfectScrollbar]="{ wheelPropagation: false }"
    >
      <ng-container
        *ngFor="let record of records"
        [ngTemplateOutlet]="recordTemplate"
        [ngTemplateOutletContext]="{ record: record }"
      ></ng-container>
    </div>
  </div>
  <div class="card-footer d-flex flex-center">
    <button #loadMore class="btn btn-primary">Load More</button>
  </div>
</div>

<ng-template #recordTemplate let-record="record">
  <div class="d-flex align-items-stretch py-2 mb-2">
    <div style="width: 160px" class="text-muted px-2">{{ getDate(record.date_created) }}</div>
    <div style="width: 230px" class="flex-grow-1 d-flex flex-column px-2">
      <div *ngFor="let patient of record.patients">
        {{ patient.name ? patient.name + ' (' + patient.pms_id + ')' : 'N/A' }}
      </div>
    </div>
    <div style="width: 230px" class="flex-grow-1 px-2">
      <div class="d-flex align-items-stretch">
        <i
          [class]="
            'fas fa-square mr-2 text-' +
            (record.transaction_type === TransactionType.TASK
              ? 'primary'
              : record.transaction_type === TransactionType.WORKFLOW_QUEUE
              ? 'danger'
              : 'warning')
          "
        ></i>
        <div class="flex-grow-1 d-flex flex-column">
          <button
            class="btn btn-link font-weight-bold text-dark text-left p-0"
            (click)="openTransaction($event, record)"
          >
            {{ record.title }}
          </button>
          <div *ngIf="record.team_name" class="text-muted">{{ record.team_name }}</div>
          <div *ngIf="record.status" class="mt-2">
            <span class="label label-lg label-light-success label-inline">{{
              record.status | uppercase
            }}</span>
          </div>
        </div>
      </div>
    </div>
    <div style="width: 230px" class="text-lines-4 px-2">{{ record.last_activity }}</div>
    <div style="width: 160px" class="text-muted px-2">
      {{ record.date | date : 'MMM dd, yyyy hh:mm a' }}
    </div>
    <div style="width: 160px" class="px-2">{{ record.last_modified_by }}</div>
    <div style="width: 85px" class="d-flex justify-content-start px-2">
      <button
        [ngbTooltip]="'Follow-Up'"
        data-placement="bottom"
        class="btn btn-sm btn-icon btn-light btn-hover-success mr-2"
        (click)="viewFollowUp($event, record)"
      >
        <i class="flaticon-calendar-with-a-clock-time-tools text-success"></i>
      </button>
      <button
        *ngIf="record.transaction_type !== TransactionType.NOTE"
        [ngbTooltip]="'Comments'"
        data-placement="bottom"
        class="btn btn-sm btn-icon btn-light btn-hover-primary"
        (click)="viewComments($event, record)"
      >
        <i class="flaticon-comment text-primary"></i>
      </button>
    </div>
  </div>
</ng-template>
